import React from 'react';

interface AuthPageLayoutProps {
  children: React.ReactNode;
}

/**
 * AuthPageLayout - Reusable layout wrapper for authentication pages
 * Provides consistent centered flexbox container for login/register views
 */
export function AuthPageLayout({ children }: AuthPageLayoutProps) {
  return (
    <main className="flex min-h-screen flex-col items-center justify-center gap-s4 p-s8">
      <div className="w-full max-w-md">
        {children}
      </div>
    </main>
  );
}
